import { Pipe, PipeTransform } from '@angular/core';

@Pipe( {
    name: 'formatSeconds'
} )
export class FormatSecondsPipe implements PipeTransform {

    transform( value: any, args?: any ): any {

        value = parseInt( value, 10 );

        if ( isNaN( value ) ) {
            return null;
        }

        const hours = Math.floor( value / 3600 );
        const minutes = Math.floor( ( value - ( hours * 3600 ) ) / 60 );
        const seconds = value - ( hours * 3600 ) - ( minutes * 60 );

        return ( hours > 0 ? hours + ':' : '' ) + ( hours > 0 && minutes < 10 ? '0' : '' ) + minutes + ':' + ( seconds < 10 ? '0' : '' ) + seconds;
    }

}
